import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setMessage(data.detail || "Login failed.");
        return;
      }

      localStorage.setItem("TTT_AUTH_TOKEN", data.token);
      localStorage.setItem("TTT_USER", JSON.stringify(data.user));

      setMessage(`Logged in as ${data.user.name}.`);
      navigate(data.user.role === "owner" ? "/admin/mockups" : "/staff/mockups");
    } catch (err) {
      console.error(err);
      setMessage("Login failed.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-zinc-900 border border-zinc-800 rounded-2xl p-6 space-y-4"
      >
        <div>
          <h1 className="text-3xl font-bold">TapToTable Login</h1>
          <p className="text-zinc-400 mt-1">
            Sign in to your staff account.
          </p>
        </div>

        <div>
          <label className="block text-sm text-zinc-300 mb-1">Email</label>
          <input
            type="email"
            className="w-full rounded-xl bg-zinc-950 border border-zinc-700 px-4 py-3"
            value={form.email}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, email: e.target.value }))
            }
            required
          />
        </div>

        <div>
          <label className="block text-sm text-zinc-300 mb-1">Password</label>
          <input
            type="password"
            className="w-full rounded-xl bg-zinc-950 border border-zinc-700 px-4 py-3"
            value={form.password}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, password: e.target.value }))
            }
            required
          />
        </div>

        <button
          disabled={loading}
          className="w-full rounded-xl bg-cyan-400 text-zinc-950 font-bold px-5 py-3 disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>

        {message && <p className="text-sm text-zinc-300">{message}</p>}
      </form>
    </div>
  );
}
